module.exports = __webpack_public_path__ + "img/63.4144a627.jpg";